module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h14"
  }, [_vm._v("Agradecimientos")]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_c('img', {
    attrs: {
      "alt": "img2.png",
      "src": "images/img2.png"
    }
  })]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("H")]), _c('span', {
    staticClass: "t8"
  }, [_vm._v("ACE")]), _c('span', {
    staticClass: "t7"
  }), _vm._v("como mil años, después de conseguir mi título de profesora, mi madrastra me llevó de compras en busca de un conjunto que llevar a las entrevistas. En un momento dado salí del vestidor y enseguida, Janis, mi madrastra, empezó a ajustarme el sujetador, a subirme los calcetines y ponerlo todo en orden mientras yo estaba allí sentada pasivamente bajo la mortificación filial. Tras un momento Janis se dio cuenta de lo que estaba haciendo y de que yo tenía veintitrés años y no ocho. ")]), _vm._v(" "), _c('p', [_vm._v("—Lo siento; date cuenta de que cuando tengas sesenta años y yo ochenta,  seguiré todavía ajustándote los calcetines —dijo.")]), _vm._v(" "), _c('p', [_vm._v("Mi madrastra se ha convertido en la defensora de los ancianos en mi hogar. Enfermera de la UCI, se ha ocupado de los últimos asuntos y de las necesidades médicas de la madre de mi padre, de la madre de su ex marido y de su propia madre. Les ha acompañado en sus últimos momentos.")]), _vm._v(" "), _c('p', [_vm._v("Es un milagro cuanto menos.")]), _vm._v(" "), _c('p', [_vm._v("Me ha enseñado todo en lo que creo sobre la vida, la muerte y sobre la amabilidad y la dignidad que tienen ambas. Si hay algo, por poco que sea, que te emocione en la relación entre Mikhail y Ylena, hay que agradecérselo a ella.")]), _vm._v(" "), _c('p', [_vm._v("Ya era hora de que yo lo hiciese.")]), _vm._v(" "), _c('p', [_vm._v("Gracias, Janis. Chica, tuve suerte.")]), _vm._v(" "), _c('p')])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1afeef34","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006.vue
// module id = 69
// module chunks = 0